/**
 * Fading Chat Title
 *
 * Stable title text for chat-like headers.
 *
 * Primary responsibilities:
 * - Keep title layout stable while the chat name changes
 * - Update title text in place without remounting header content
 *
 * Dependencies:
 * - React
 */

"use client"

type FadingChatTitleProps = {
  title: string
}

export function FadingChatTitle({ title }: FadingChatTitleProps) {
  const label = title.trim() || "Untitled chat"

  return (
    <span className="block min-h-[1.25em] min-w-0 truncate" title={label}>
      {label}
    </span>
  )
}
